export const TIPO_DOCUMENTO_OPTS = [
  { value: 'remision', label: 'Cotización' },
  { value: 'iva', label: 'Factura' },
];

export const FORMA_PAGO_OPTS = [
  { value: 'contado', label: 'Contado' },
  { value: 'credito_15', label: 'Crédito 15 días' },
  { value: 'credito_20', label: 'Crédito 20 días' },
  { value: 'credito_30', label: 'Facturación a 30 días' },
];

export function labelTipoDocumento(v) {
  if (!v) return null;
  return TIPO_DOCUMENTO_OPTS.find((o) => o.value === v)?.label || v;
}

export function labelFormaPago(v) {
  if (!v) return null;
  return FORMA_PAGO_OPTS.find((o) => o.value === v)?.label || v;
}
